import { useSelector } from 'react-redux';
import TestList from './TestList';

export default function MyTests() {
  const user = useSelector((state) => state.GlobalReducer.loggedUser);

  return <TestList patient={user} />;
}
